<template>
  <div class="welcome-section px-6 2xl:px-20 py-32">
    <ArticlesRenderLegal :type="(<string>router.params.name)?.replace('- ', '_')"/>
  </div>
</template>
<script lang="ts" setup>

definePageMeta({
})

// ---------------------------------------
// Hooks
// ---------------------------------------

const { t } = useI18n();
const router = useRoute()

// ---------------------------------------
// State
// ---------------------------------------
const pageTitle = computed(() => {
  const titles = {
    'privacy-policy': t('privacy_policy'),
    'refund-policy': t('refund_policy'),
    'terms-of-use': t('terms_of_use'),
  }

  return titles[router.params.name as keyof typeof titles];
});

// ---------------------------------------
// Meta
// ---------------------------------------

useHead({
  title: pageTitle.value,

});
</script>
